import React, { useState } from "react";

interface HamburgerBtnProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isOpen?: boolean;
  toggle?: () => void;
  size?: number;
}

const HamburgerBtn: React.FC<HamburgerBtnProps> = ({
  isOpen,
  toggle,
  size = 50,
  className,
  onClick,
  ...props
}) => {
  const [pressed, setPressed] = useState(false);
  const [internalOpen, setInternalOpen] = useState(false);

  const opened = isOpen ?? internalOpen;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(e);
    if (toggle) toggle();
    else setInternalOpen(!internalOpen);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onMouseLeave={() => setPressed(false)}
      onTouchStart={() => setPressed(true)}
      onTouchEnd={() => setTimeout(() => setPressed(false), 100)}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        backgroundColor: "#333333",
        transform: pressed ? "scale(0.95)" : "scale(1)",
        transition: "transform 0.2s ease, opacity 0.2s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "8px",
        cursor: "pointer",
        opacity: pressed ? 0.9 : 1,
      }}
      className={className}
      {...props}
    >
      <div
        style={{
          position: "relative",
          width: "60%",
          height: "2px",
          backgroundColor: opened ? "transparent" : "white",
          transition: "background-color 0.2s ease",
        }}
      >
        <span
          style={{
            position: "absolute",
            top: opened ? 0 : -8,
            left: 0,
            width: "100%",
            height: "2px",
            backgroundColor: "white",
            transform: opened ? "rotate(45deg)" : "rotate(0)",
            transition: "transform 0.3s ease, top 0.3s ease",
          }}
        />
        <span
          style={{
            position: "absolute",
            top: opened ? 0 : 8,
            left: 0,
            width: "100%",
            height: "2px",
            backgroundColor: "white",
            transform: opened ? "rotate(-45deg)" : "rotate(0)",
            transition: "transform 0.3s ease, top 0.3s ease",
          }}
        />
      </div>
    </button>
  );
};

export default HamburgerBtn;
